module.exports = __webpack_public_path__ + "img/1618787830.0318ee58.png";